import { render, staticRenderFns } from "./OrganizationActualSpecialistTable.vue?vue&type=template&id=d98f145c&scoped=true&"
import script from "./OrganizationActualSpecialistTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationActualSpecialistTable.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationActualSpecialistTable.vue?vue&type=style&index=0&id=d98f145c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98f145c",
  null
  
)

export default component.exports